import { Component, OnInit } from '@angular/core';
import { User } from '../_models/index';
import { AlertService, UserService } from '../_services/index';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {
	model: any = {};
    currentUser: User;
    teams$: Observable<Object[]>;
    teamlist: Array<Object>=[];
    rolelist: Array<Object>=[];
    users: User[] = [];
    loading = false;

	constructor(private userService: UserService, private router: Router, private alertService: AlertService) {
		this.userService.getById(JSON.parse(localStorage.getItem('currentUserId')).id)
	    .subscribe(
	        data => {
	            this.model.username = data["username"]
	            this.model.first_name = data["first_name"]
	            this.model.last_name = data["last_name"]
	            this.model.email = data["email"]
	            this.model.organization = data["organization"]
	            this.model.team = data["team"]
	            this.model.role = data["role"]
	            this.model.id = data["id"]
	            /*this.model.password = data["password"]*/

	        },
	        error => {
	            this.alertService.error(error);
	            this.loading = false;
	    });

	}
	ngOnInit() {
		this.rolelist = [{id:1,name:'National Team Member'},{id:2,name:'Generic User'}];
    this.teams$ = this.userService.getTeams();
    this.teams$
    .subscribe(
        data => {
        this.teamlist = data;
        });
	}

    update() {
    	this.loading = true;
      this.userService.update(this.model)
          .subscribe(
              data => {
                  this.alertService.success('Successfully Updated User', true);
                  this.router.navigate(['/home']);
              },
              error => {
                  this.alertService.error('Something went wrong, please try again.');
                  this.loading = false;
              });

    }

}



// WEBPACK FOOTER //
// ./src/app/profile/profile.component.ts